import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactTags from 'react-tag-autocomplete';

import RaisedButton from 'material-ui/RaisedButton';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import api from 'services';
import styles from 'styles';
import { saveArea, updateAreaSuggestions, updateAreaAlt } from 'actions/regions/areas';

class AreasAltNamesRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: props.item,
            tags: props.tags,
        };

        this.handleAddition = this.handleAddition.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.updateArea = this.updateArea.bind(this);
    }

    updateArea() {
        this.props.updateAreaAlt(this.state.item);
    }

    handleInputChange(searchText) {
        if (searchText.length < 3) {
            this.props.updateAreaSuggestions([]);
            return;
        }

        api.findPortAdmin({ name: searchText, withAreas: true })
            .then((response) => {
                this.props.updateAreaSuggestions(response.data.data);
            });
    }

    handleDelete(i) {
        const tags = this.state.tags.slice(0);
        tags.splice(i, 1);

        const item = this.state.item;
        item.isUpdate = true;
        item.alt = tags.map(newTag => newTag.name);

        this.setState({ tags, item }, () => {
            this.props.updateAreaSuggestions([]);
            this.props.saveArea(this.state.item);
        });
    }

    handleAddition(tag) {
        if (!tag.name.replace(/\s/g, '').length) {
            return;
        }

        const suggestionsAreas = this.props.suggestionsAreas.filter((item) => {
            if (item.name.toLowerCase() === tag.name.toLowerCase()) {
                return true;
            }
            return false;
        });

        if (suggestionsAreas.length) {
            return;
        }

        const tags = [].concat(this.state.tags, tag);
        const item = this.state.item;
        item.isUpdate = true;
        item.alt = tags.map(newTag => newTag.name);

        this.setState({ tags, item }, () => {
            this.props.updateAreaSuggestions([]);
            this.props.saveArea(this.state.item);
        });
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        this.setState({
            tags: newProps.tags,
            item: newProps.item,
        });
    }

    render() {
        return (
            <TableRow>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {this.props.item.name}
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    <ReactTags
                        allowNew
                        autofocus={false}
                        tags={this.state.tags}
                        suggestions={[]}
                        handleDelete={this.handleDelete}
                        handleAddition={this.handleAddition}
                        handleInputChange={this.handleInputChange}
                    />
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    <div className={this.props.item.isUpdate ? 'update-item' : 'hidden update-item'}>
                        <RaisedButton label='Update' primary onClick={this.updateArea} />
                    </div>
                </TableRowColumn>
            </TableRow>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const tags = ownProps.item.alt.map((item, key) => ({
            id: key,
            name: item,
        }));

        return {
            item: ownProps.item,
            tags,
            suggestionsAreas: state.areas.suggestions,
        };
    },
    dispatch => bindActionCreators(
        {
            saveArea,
            updateAreaSuggestions,
            updateAreaAlt,
        },
        dispatch,
    ),
)(AreasAltNamesRow);



// WEBPACK FOOTER //
// ./app/components/Regions/AreasAltNames/Row.jsx